import {
  faChevronUp,
  faMicrophone,
  faMicrophoneSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Room } from "livekit-client";
import React, { useCallback, useEffect, useState } from "react";
import { Popover } from "react-tiny-popover";

import styles from "./styles.module.css";

export interface AudioSelectButtonProps {
  isMuted: boolean;
  onClick?: () => void;
  onSourceSelected?: (device: MediaDeviceInfo) => void;
  isButtonDisabled?: boolean;
  requestPermissions?: boolean;

  showDropdown?: boolean;
}

interface MenuItem {
  label: string;
}

export const AudioSelectButton = ({
                                    isMuted,
                                    onClick,
                                    onSourceSelected,
                                    isButtonDisabled,
                                    requestPermissions = true,
                                    showDropdown = true,
                                  }: AudioSelectButtonProps) => {
  const [sources, setSources] = useState<MediaDeviceInfo[]>([]);
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const [menuVisible, setMenuVisible] = useState(false);

  const listAudioDevices = useCallback(async () => {
    const devices = await Room.getLocalDevices(
      "audioinput",
      requestPermissions
    );

    setSources(devices);

    setMenuItems(
      devices.map((device) => ({
        label: device.label,
      }))
    );
  }, [requestPermissions]);

  useEffect(() => {
    listAudioDevices();

    navigator.mediaDevices.addEventListener(
      "devicechange",
      listAudioDevices
    );

    return () => {
      navigator.mediaDevices.removeEventListener(
        "devicechange",
        listAudioDevices
      );
    };
  }, [listAudioDevices]);

  const handleMenuItem = (item: MenuItem) => {
    const device = sources.find(
      (source) => source.label === item.label
    );

    if (device && onSourceSelected) {
      onSourceSelected(device);
    }

    setMenuVisible(false);
  };

  return (
    <Popover
      isOpen={menuVisible}
      positions={["top"]}
      padding={10}
      align="end"
      onClickOutside={() => setMenuVisible(false)}
      content={
        <div className={styles.audioPopover}>
          <ul className={styles.audioDeviceList}>
            {menuItems.map((item, index) => (
              <li
                key={index}
                className={styles.audioDeviceItem}
                onClick={() => handleMenuItem(item)}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      }
    >
      <div className={styles.audioButtonWrapper}>
        <button
          disabled={isButtonDisabled}
          className={styles.audioMainButton}
          onClick={onClick}
        >
          <FontAwesomeIcon
            icon={
              isMuted
                ? faMicrophoneSlash
                : faMicrophone
            }
          />
        </button>

        {showDropdown && (
          <button
            disabled={isButtonDisabled}
            className={styles.audioDropdownButton}
            onClick={() => setMenuVisible((v) => !v)}
          >
            <FontAwesomeIcon icon={faChevronUp} />
          </button>
        )}
      </div>
    </Popover>
  );
};
